import React from 'react';
import ask from '../img/ask.svg';
import dev from '../img/dev.svg';
import keep from '../img/keep.svg';
import app from '../img/app.svg';
import intelligent from '../img/intelligent.svg';
import safe from '../img/safe.svg';
import bg from '../img/bg13.jpg';
import banner from '../img/banner.jpg';
export const Nav00DataSource = {
  wrapper: { className: 'header0 home-page-wrapper' },
  page: { className: 'home-page' },
  logo: {
    href: '#',
    className: 'header0-logo',
    style: {
      width: 'auto',
      color: '#fff',
      fontWeight: 600,
      fontSize: '24px',
    },
    children: '深圳市垚垚互娱科技有限公司'
  },
  Menu: {
    className: 'header0-menu',
    children: [
      {
        name: 'item0',
        className: 'header0-item',
        children: {
          href: '#Banner2_1',
          children: [{ children: '首页', name: 'text' }],
        },
      },
      {
        name: 'item1',
        className: 'header0-item',
        children: {
          href: '#Feature0_1',
          children: [{ children: '服务', name: 'text' }],
        },
      },
      // {
      //   name: 'item2',
      //   className: 'header0-item',
      //   children: {
      //     href: '#',
      //     children: [{ children: '产品', name: 'text' }],
      //   },
      // },
      {
        name: 'item3',
        className: 'header0-item',
        children: {
          href: '#Feature4_0',
          children: [{ children: '关于', name: 'text' }],
        },
      },
    ],
  },
  mobileMenu: { className: 'header0-mobile-menu' },
};
export const Banner21DataSource = {
  wrapper: { className: 'banner2' },
  BannerAnim: {
    children: [
      {
        name: 'elem0',
        BannerElement: { className: 'banner-user-elem' },
        page: { className: 'home-page banner2-page' },
        textWrapper: { className: 'banner2-text-wrapper' },
        bg: { className: 'bg bg0' },
        title: { className: 'banner2-title', children: '深圳市垚垚互娱科技有限公司' },
        content: {
          className: 'banner2-content',
          children: '赋能企业数字化转型',
        },
        button: { href: '#Feature4_0', className: 'banner2-button', children: '关于' },
      },
    ],
  },
};
export const Feature01DataSource = {
  wrapper: { className: 'home-page-wrapper content0-wrapper' },
  page: { className: 'home-page content0' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [{ name: 'title', children: '服务' }],
  },
  childWrapper: {
    className: 'content0-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'toImage',
              className: 'content0-block-icon',
              children: ask,
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: '咨询与规划',
            },
            { name: 'content', children: '信息技术咨询服务、安全咨询服务、技术服务咨询' },
          ],
        },
      },
      {
        name: 'block1',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'toImage',
              className: 'content0-block-icon',
              children: dev,
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: '开发与实施',
            },
            {
              name: 'content',
              children: '软件开发、网络与信息安全软件开发、信息系统集成服务',
            },
          ],
        },
      },
      {
        name: 'block2',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'toImage',
              className: 'content0-block-icon',
              children: keep,
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: '运维与支持',
            },
            {
              name: 'content',
              children: '信息系统运行维护服务、网络技术服务、技术推广',
            },
          ],
        },
      },
    ],
  },
};
export const Feature40DataSource = {
  wrapper: { className: 'home-page-wrapper content6-wrapper' },
  OverPack: { className: 'home-page content6' },
  textWrapper: { className: 'content6-text', xs: 24, md: 10 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: '关于',
        className: 'title-h1',
      },
      {
        name: 'content',
        className: 'title-content',
        children: '深圳市垚垚互娱科技有限公司一直遵循“客户第一、员工第二、公司第三”的宗旨，牢固树立为客户创造价值的核心服务理念，向我们的客户提供最优质、最高效、最专业、最满意的服务。我们不懈地努力，不懈地追求，不断地超越自己。',
      },
    ],
  },
  img: {
    children: bg,
    className: 'content6-img',
    xs: 24,
    md: 14,
  },
  block: {
    children: [
      {
        name: 'block0',
        img: {
          children: app,
          className: 'content6-icon',
        },
        title: { className: 'content6-title', children: '产品优化支持' },
        content: {
          className: 'content6-content',
          children:
            '我们非常了解应用工具以及国内用户，我们将帮助您优化产品，我们在用户体验，交互界面，内容以及技术方面给您给予支持建议。',
        },
      },
      {
        name: 'block1',
        img: {
          className: 'content6-icon',
          children: intelligent,
        },
        title: { className: 'content6-title', children: '多元化用户获取手段和渠道' },
        content: {
          className: 'content6-content',
          children:
            '精准触达目标用户的技术实践，深度整合多家主流平台接口，支持一键式多端投放与数据追踪。',
        },
      },
      {
        name: 'block2',
        img: {
          className: 'content6-icon',
          children: safe,
        },
        title: { className: 'content6-title', children: '原创保护' },
        content: {
          className: 'content6-content',
          children:
            '我们将联手法务团队，竭力保护您的知识产权，打击盗版应用工具产品。',
        },
      },
    ],
  },
};
export const Footer00DataSource = {
  wrapper: { className: 'home-page-wrapper footer0-wrapper' },
  OverPack: { className: 'home-page footer0', playScale: 0.05 },
  copyright: {
    className: 'm82glv6849-editor_css copyright',
    children: (
      <span>
        <span>
          <span>
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <p>
                            深圳市南山区南山街道南山社区南新路阳光科创中心一期B座2402
                            <br />
                            <a href='https://beian.miit.gov.cn/'>粤ICP备2025464126号-1</a>
                            </p>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          </span>
        </span>
      </span>
    ),
  },
};
